// Distinct color themes for each of the 12 packages.
// Each theme: { from, to, glow } — used across package cards, badges, etc.
export const PACKAGE_COLORS = [
  { from: '#22D3EE', to: '#0891B2', glow: 'rgba(34, 211, 238, 0.4)' },   // 1 · Cyan
  { from: '#7C3AED', to: '#5B21B6', glow: 'rgba(124, 58, 237, 0.4)' },   // 2 · Violet
  { from: '#EC4899', to: '#BE185D', glow: 'rgba(236, 72, 153, 0.4)' },   // 3 · Magenta
  { from: '#F59E0B', to: '#D97706', glow: 'rgba(245, 158, 11, 0.4)' },   // 4 · Amber
  { from: '#10D9A0', to: '#059669', glow: 'rgba(16, 217, 160, 0.4)' },   // 5 · Emerald
  { from: '#EF4444', to: '#B91C1C', glow: 'rgba(239, 68, 68, 0.4)' },    // 6 · Red
  { from: '#8B5CF6', to: '#6D28D9', glow: 'rgba(139, 92, 246, 0.4)' },   // 7 · Purple
  { from: '#3B82F6', to: '#1D4ED8', glow: 'rgba(59, 130, 246, 0.4)' },   // 8 · Blue
  { from: '#F97316', to: '#C2410C', glow: 'rgba(249, 115, 22, 0.4)' },   // 9 · Orange
  { from: '#06B6D4', to: '#0369A1', glow: 'rgba(6, 182, 212, 0.4)' },    // 10 · Sky
  { from: '#A855F7', to: '#7E22CE', glow: 'rgba(168, 85, 247, 0.4)' },   // 11 · Fuchsia
  { from: '#FBBF24', to: '#B45309', glow: 'rgba(251, 191, 36, 0.5)' }    // 12 · Gold
];

export const getPackageColor = (pkgId) => PACKAGE_COLORS[(pkgId - 1) % PACKAGE_COLORS.length];
